function scrollFunction () {
    if (document.body.scrollTop > ($('.header').height() + $('.tabs').height()) ||
        document.documentElement.scrollTop > ($('.header').height() + $('.tabs').height())) {
        $('.scroll-top').removeClass('hidden')
    } else {
        $('.scroll-top').addClass('hidden')
    }
}

export { scrollFunction }
